/**
 * CRC manual override actions exposed in the eligibility details UI.
 *
 * Each value maps to an existing eligibility API (override PUT or override intent).
 */

/** Supported override disposition selected in the manual override modal. */
export enum ManualOverrideDisposition {
  MarkNotMetContinue = "MARK_NOT_MET_CONTINUE",
  MarkNotMetIneligible = "MARK_NOT_MET_INELIGIBLE",
  SkipContinue = "SKIP_CONTINUE",
  MarkMetContinue = "MARK_MET_CONTINUE",
}

/** User-visible label for each {@link ManualOverrideDisposition}. */
export const MANUAL_OVERRIDE_DISPOSITION_LABELS: Record<
  ManualOverrideDisposition,
  string
> = {
  [ManualOverrideDisposition.MarkNotMetContinue]:
    "Mark the Criteria as Not Met and Continue Evaluation",
  [ManualOverrideDisposition.MarkNotMetIneligible]:
    "Mark the Criteria as Not Met and Patient as Ineligible",
  [ManualOverrideDisposition.SkipContinue]:
    "Skip the Criteria and Continue Evaluation",
  [ManualOverrideDisposition.MarkMetContinue]:
    "Mark the Criteria as Met and Continue Evaluation",
};
